// packages/shared-components/src/components/Checkbox/Checkbox.tsx

import { useState } from "react";
import { CheckboxProps } from "./types";
import styles from "./Checkbox.module.css";

export function Checkbox({
  checked: controlledChecked,
  defaultChecked = false,
  onChange,
  label,
  labelPosition = "right",
  disabled = false,
  className = "",
  shape = "square",
}: CheckboxProps) {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);

  const isControlled = controlledChecked !== undefined;
  const checked = isControlled ? controlledChecked : internalChecked;

  const handleClick = () => {
    if (disabled) return;

    const newChecked = !checked;

    if (!isControlled) {
      setInternalChecked(newChecked);
    }

    onChange?.(newChecked);
  };

  const containerClasses = `${styles.checkbox} ${
    checked ? styles.checked : ""
  } ${disabled ? styles.disabled : ""} ${className}`;

  return (
    <div className={containerClasses} onClick={handleClick}>
      {label && labelPosition === "left" && (
        <span className={`${styles.label} ${styles.labelLeft}`}>{label}</span>
      )}

      <div
        className={styles.box}
        style={{ borderRadius: shape === "circle" ? "50%" : "" }}
      >
        <svg
          className={styles.icon}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5 4.5L6 12L2.5 8.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {label && labelPosition === "right" && (
        <span className={`${styles.label} ${styles.labelRight}`}>{label}</span>
      )}
    </div>
  );
}
